import { useMemo } from 'react'

import { isAuthenticated } from '../../../../domain'
import {
  AnonymousCondition,
  DisclosureSectionCondition,
} from '../../../../state/configuration'
import { usePolicyholder, usePrincipal } from '../../../authentication'

export const useAnonymousCondition = () => {
  const { policyholder } = usePolicyholder()
  const principal = usePrincipal()

  return useMemo(
    () => (condition: AnonymousCondition) =>
      isAuthenticated(policyholder, principal) !== condition.isAnonymousOnly,
    [policyholder],
  )
}

export const useSectionConditions = () => {
  const anonymousCondition = useAnonymousCondition()

  return useMemo(
    () => (it: DisclosureSectionCondition) => {
      switch (it.type) {
        case 'anonymous':
          return anonymousCondition(it as AnonymousCondition)
      }
    },
    [anonymousCondition],
  )
}
